import api from "../../api";
import { userSummaryEndpoint } from "../../api/apisUrl";
import { apiError } from "../../models";
import {
  USER_SUMMARY_FAILD,
  USER_SUMMARY_LOADING,
  USER_SUMMARY_SUCCESS,
} from "../types";

export const getUserSummary = (token: string, id: string) => {
  return async (
    dispatch: (arg0: {
      type: string;
      loading?: boolean;
      payload?: any;
      error?: any;
    }) => void
  ) => {
    dispatch({ type: USER_SUMMARY_LOADING, loading: true });
    await api
      .get(userSummaryEndpoint(id), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        dispatch({ type: USER_SUMMARY_LOADING, loading: false });
        dispatch({ type: USER_SUMMARY_SUCCESS, payload: res.data });
      })
      .catch((err) => {
        apiError(USER_SUMMARY_LOADING, USER_SUMMARY_FAILD, err, dispatch);
      });
  };
};
